import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { ApplicationsService } from 'src/app/shared/services/applications/applications.service';
import { ApplicationsStore } from 'src/app/shared/stores/applications/applications.store';
import { ClientStore } from 'src/app/shared/stores/client/client.store';

/**
 * Lightweight resolver that ensures applications are loaded before fact-find routes.
 *
 * This resolver only loads applications if they haven't been loaded yet,
 * avoiding unnecessary API calls when navigating within the app.
 *
 * Required for fact-find save operations which need selectedApplication.
 */
export const applicationsResolver: ResolveFn<boolean> = () => {
  const applicationsStore = inject(ApplicationsStore);
  const applicationsService = inject(ApplicationsService);
  const clientStore = inject(ClientStore);

  const client = clientStore.client();
  if (!client?.clientId) {
    return of(false);
  }

  const storeMatchesClient =
    applicationsStore.isLoaded() && applicationsStore.clientId() === client.clientId;

  if (storeMatchesClient) {
    return of(true);
  }

  return applicationsService.get(client.clientId).pipe(
    take(1),
    map(() => true),
    catchError(() => of(false))
  );
};
